import { gql } from '@apollo/client'
import {
  CONTACT_DETAIL_FRAGMENT,
  SOCIETY_FRAGMENT,
  PAGINATION_FRAGMENT,
} from '../Fragments'
import { USER_FRAGMENT } from './User'

export const CONFORMITY_DOMICILIATION_FRAGMENT = gql`
  fragment ConformityDomiciliationFragment on Domiciliation {
    id
    kbis
    clientSince
    address {
      id
      shortname
      fullAddress
    }
    contactDetail {
      ...ContactDetailFragment
    }
    society {
      name
      brandName
      ...SocietyFragment
    }
  }
  ${CONTACT_DETAIL_FRAGMENT}
  ${SOCIETY_FRAGMENT}
`

export const CONFORMITY_FRAGMENT = gql`
  fragment ConformityFragment on Conformity {
    id
    siren
    moderator {
      ...UserFragment
    }
    previousModerator {
      ...UserFragment
    }
    checkedAt
    domiciliation {
      ...ConformityDomiciliationFragment
    }
  }
  ${CONFORMITY_DOMICILIATION_FRAGMENT}
  ${USER_FRAGMENT}
`

export const CONFORMITIES_PAGINATED_FRAGMENT = gql`
  fragment ConformitiesPaginatedFragment on ConformitiesPaginated {
    pagination {
      ...PaginationFragment
    }
    conformities {
      ...ConformityFragment
    }
  }
  ${CONFORMITY_FRAGMENT}
  ${PAGINATION_FRAGMENT}
`

export const CONFORMITY_STATS_FRAGMENT = gql`
  fragment ConformityStatsFragment on ConformityStats {
    assignedInMonthCount
    doneInMonthCount
    doneTodayCount
    todoTodayCount
  }
`

export const CONFORMITY_QUERY = gql`
  query conformitiesPage(
    $pagination: PaginationInput!
    $addressId: Int
    $moderatorId: Int
    $sorter: SorterInput
    $filters: [FilterInput!]
  ) {
    conformitiesPage(
      pagination: $pagination
      addressId: $addressId
      moderatorId: $moderatorId
      sorter: $sorter
      filters: $filters
    ) {
      ...ConformitiesPaginatedFragment
    }
  }
  ${CONFORMITIES_PAGINATED_FRAGMENT}
`

export const CONFORMITY_STATS_QUERY = gql`
  query conformityUserStatsPage($userId: Int!) {
    conformityUserStats(userId: $userId) {
      ...ConformityStatsFragment
    }
  }
  ${CONFORMITY_STATS_FRAGMENT}
`

export const UPDATE_CONFORMITY_STATE = gql`
  mutation updateConformityState(
    $id: Int!
    $state: String!
    $siret: String
    $associationId: String
    $denomination: String
    $enterpriseCreatedDate: ISO8601DateTime
    $enterpriseClosedDate: ISO8601DateTime
  ) {
    updateConformityState(
      id: $id
      state: $state
      siret: $siret
      associationId: $associationId
      denomination: $denomination
      enterpriseCreatedDate: $enterpriseCreatedDate
      enterpriseClosedDate: $enterpriseClosedDate
    ) {
      conformity {
        ...ConformityFragment
      }
    }
  }
  ${CONFORMITY_FRAGMENT}
`
